"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Category = exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["MOVEMENT"] = "MOVEMENT";
    EventType["AUDIT"] = "AUDIT";
    EventType["RESERVATION"] = "RESERVATION";
})(EventType = exports.EventType || (exports.EventType = {}));
var Category;
(function (Category) {
    Category["ALLOCATION"] = "ALLOCATION";
    Category["PICKING"] = "PICKING";
    Category["PACKING"] = "PACKING";
    Category["SHIPPED"] = "SHIPPED";
    Category["OTHER"] = "OTHER";
    Category["CONSUMED"] = "CONSUMED";
    Category["RESTORED"] = "RESTORED";
    Category["REGISTER"] = "REGISTER";
    Category["UNREGISTER"] = "UNREGISTER";
})(Category = exports.Category || (exports.Category = {}));
//# sourceMappingURL=Event.js.map